import { PlaceholderReplacement } from '@tools/replacePlaceholders'

import { AccidentAtlasRegionId } from './region'

export type AccidentAtlasChartType = 'line' | 'column' | 'pie'

export type AccidentAtlasChartAxis = {
  name: string
  categories: string[]
}

export type AccidentAtlasChartYAxis = {
  name: string
}

export type AccidentAtlasChartDataSeries = {
  name: string
  data: number[]
  unit?: string | null
}

export type AccidentAtlasCartesianChartConfig = {
  chartType: 'line' | 'column'
  xAxis: AccidentAtlasChartAxis
  yAxis: AccidentAtlasChartYAxis
  series: AccidentAtlasChartDataSeries[]
}

export type AccidentAtlasPieChartDataset = {
  data: number[]
}

export type AccidentAtlasPieChartConfig = {
  chartType: 'pie'
  labels: string[]
  datasets: AccidentAtlasPieChartDataset[]
}

export type AccidentAtlasChartConfig =
  | AccidentAtlasCartesianChartConfig
  | AccidentAtlasPieChartConfig

export function isCartesianChartConfig(
  chartConfig: AccidentAtlasChartConfig
): chartConfig is AccidentAtlasCartesianChartConfig {
  return chartConfig.chartType === 'line' || chartConfig.chartType === 'column'
}

export function isPieChartConfig(
  chartConfig: AccidentAtlasChartConfig
): chartConfig is AccidentAtlasPieChartConfig {
  return chartConfig.chartType === 'pie'
}

export type AccidentAtlasTextConfig = {
  replacements: PlaceholderReplacement[]
}

export type AccidentAtlasApiTile = {
  tile_id: string
  textConfig: AccidentAtlasTextConfig
  chartConfig?: AccidentAtlasChartConfig
}

export type AccidentAtlasApiRegion = {
  region_id: AccidentAtlasRegionId
  region_name: string
  tiles: AccidentAtlasApiTile[]
}

export type AccidentAtlasApiResponse = AccidentAtlasApiRegion[]
